export default "__VITE_ASSET__DtzS2tCA__"